import { Component } from '@angular/core';
import { UserFacade } from '@nx-ratenow/core/data-access-user';
import { AuthService } from '@nx-ratenow/core/feature-auth';
import { ToasterService } from '@nx-ratenow/core/feature-notifications';
import { PopoverRef } from '@nx-ratenow/shared/feature-popover';

@Component({
  standalone: false,
  selector: 'nx-ratenow-ui-user-menu',
  templateUrl: './ui-user-menu.component.html',
  styleUrls: ['./ui-user-menu.component.scss']
})
export class UiUserMenuComponent {
  constructor(
    private readonly popoverRef: PopoverRef,
    private userFacade: UserFacade,
    private authService: AuthService,
    private toasterService: ToasterService
  ) {}

  logOut(): void {
    this.authService.logout().subscribe(() => {
      this.userFacade.logOut();
      this.toasterService.warning('login.com-back-soon');
    });
    this.close();
  }

  close(): void {
    /** Wait for animation to complete and then close */
    setTimeout(() => this.popoverRef.close(), 250);
  }
}
